import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { ConfiguracaoEmissaoNotaFiscal } from "./containers/ConfiguracaoEmissaoNotaFiscal";
import { ConfiguracaoRecebimentoNotaFiscal } from "./containers/ConfiguracaoRecebimentoNotaFiscal";

export const Contabilidade = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Box sx={{ width: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', pt: '2rem' }}>
            <Tabs value={tabIndex} onChange={(_, newValue) => setTabIndex(newValue)} centered>
                <Tab label="Emissão" />
                <Tab label="Recebimento" />
            </Tabs>

            {tabIndex == 0 && <ConfiguracaoEmissaoNotaFiscal />}
            {tabIndex == 1 && <ConfiguracaoRecebimentoNotaFiscal />}
        </Box>
    );
};
